import ExpandLess from '@mui/icons-material/ArrowBackIos'
import ExpandMore from '@mui/icons-material/ArrowForwardIos'
import { Box, ClickAwayListener, Popper, Typography } from '@mui/material'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import IconsList from 'common/constants/icons_map'
import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'

const DropRightButton = ({ current_menu, handleClick, Icono, open, small }) => {
  const [anchorEl, setAnchorEl] = useState(null)

  const isOpen = useMemo(() => {
    return current_menu?.id === open
  }, [current_menu?.id, open])

  const backgroundColor = useMemo(() => {
    return isOpen ? 'menu.hoverBackground' : 'menu.background'
  }, [isOpen])

  const handleClickAway = () => {
    if (!isOpen) return
    handleClick({ currentTarget: { id: String(current_menu.id) } })
  }

  return (
    <Box key={current_menu.id} sx={{ position: 'relative', ml: 1 }}>
      <ListItemButton
        ref={setAnchorEl}
        sx={{
          p: '4px',
          pl: 2,
          pr: 1,
          borderTopLeftRadius: '15px',
          borderBottomLeftRadius: '15px',
          backgroundColor: backgroundColor,
          '&:hover, &:focus': {
            backgroundColor: backgroundColor,
          },
        }}
        key={current_menu.id}
        id={current_menu.id}
        onClick={handleClick}
        className="menu-list-item"
      >
        <ListItemIcon sx={{ minWidth: small ? '36px' : '56px' }}>
          {Icono ? <Icono sx={{ color: 'background.menuContrast', opacity: '0.8' }} /> : null}
        </ListItemIcon>
        {!small ? <ListItemText primary={current_menu.nombre} /> : ''}
        {isOpen ? (
          <ExpandLess sx={{ ml: small ? 1 : 2 }} fontSize="small" />
        ) : (
          <ExpandMore sx={{ ml: small ? 1 : 2 }} fontSize="small" />
        )}
      </ListItemButton>
      <Popper
        open={isOpen}
        anchorEl={anchorEl}
        placement="right-start"
        modifiers={[
          { name: 'offset', options: { offset: [-52, 0] } },
          { name: 'preventOverflow', options: { altAxis: true, tether: false } },
        ]}
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 10 }}
      >
        <ClickAwayListener onClickAway={handleClickAway}>
          <Box
            sx={{
              backgroundColor: 'menu.hoverBackground',
              color: 'background.menuContrast',
              borderBottomRightRadius: '20px',
              borderTopRightRadius: '20px',
              p: 2,
              boxShadow: 3,
            }}
          >
            <List
              key={`ool-${current_menu.id}`}
              component="div"
              disablePadding
              sx={{ width: 'auto' }}
            >
              <ListItemText
                key={`lit-${current_menu.id}`}
                primary={
                  <Typography
                    sx={{ pl: 1, textWrap: 'nowrap', fontSize: '1.2rem', fontWeight: 'bold' }}
                  >
                    {current_menu.nombre}
                  </Typography>
                }
              />
              {current_menu.hijos.map((sub) => {
                if (sub.cod_padre !== current_menu.codigo || sub.visible !== 'S') return null
                const IconoHijo = sub?.icono ? IconsList[sub.icono] : null
                const to =
                  sub.programa === 'url' ? sub.camino : `/${sub.camino ? sub.camino : sub.programa}`
                const target = sub.programa === 'url' ? '_blank' : null
                const rel = sub.programa === 'url' ? 'noopener' : null
                const locationState = { report: sub.objeto_programa }

                if (sub.programa) {
                  return (
                    <ListItemButton
                      key={`lit-${current_menu.id}-${sub.id}`}
                      sx={{ p: '4px', pl: 1, pr: 1 }}
                      id={sub.id}
                      component={Link}
                      to={to}
                      state={
                        sub.programa === 'informes' && sub.objeto_programa ? locationState : {}
                      }
                      target={target}
                      rel={rel}
                    >
                      <ListItemIcon>
                        {IconoHijo ? <IconoHijo sx={{ color: 'background.menuContrast' }} /> : null}
                      </ListItemIcon>
                      <ListItemText
                        sx={{ textWrap: 'nowrap' }}
                        primary={<Typography>{sub.nombre}</Typography>}
                      />
                    </ListItemButton>
                  )
                }
                return null
              })}
            </List>
          </Box>
        </ClickAwayListener>
      </Popper>
    </Box>
  )
}

export default DropRightButton
